<template>
  <div v-if="isVisible" class="stars">
    <div
      v-for="n in 5"
      :key="n"
      class="star"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            :id="`gradient-${randomNumber}-${n}`"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
          >
            <stop :offset="getOffset(n)" :stop-color="filledStarColor" />
            <stop :offset="getOffset(n)" :stop-color="emptyStarColor" />
          </linearGradient>
        </defs>
        <path
          d="M34.3337 3.44913L42.5047 20.0061L60.7757 22.6611C62.9077 22.9711 63.7587 25.5911 62.2157 27.0941L48.9957 39.9811L52.1167 58.1781C52.4807 60.3011 50.2527 61.9201 48.3457 60.9181L32.0027 52.3271L15.6607 60.9191C13.7537 61.9211 11.5257 60.3021 11.8897 58.1791L15.0107 39.9821L1.78973 27.0931C0.246732 25.5891 1.09873 22.9691 3.22973 22.6601L21.5007 20.0051L29.6717 3.44813C30.6257 1.51713 33.3797 1.51713 34.3337 3.44913Z"
          :fill="`url(#gradient-${randomNumber}-${n})`"
        />
      </svg>
    </div>
    <span v-if="getNumber(count)"> ({{ getNumber(count) }})</span>
  </div>
</template>

<script>
export default {
  props: {
    average: {
      type: String, default: null
    },
    count: {
      type: String, default: null
    },
    emptyStarColor: {
      type: String, default: '#efefef'
    },
    filledStarColor: {
      type: String, default: '#fcc01d'
    }
  },
  data () {
    return {
      randomNumber: Math.floor(Math.random() * 10000)
    }
  },
  computed: {
    isVisible () {
      return this.average !== null || (this.average && this.average.length)
    }
  },
  methods: {
    getNumber (value) {
      if (typeof value !== 'string') { return 0 }
      const match = value.match(/\d+(\.\d+)?/)

      return match ? parseFloat(match[0]) : 0
    },
    getOffset (n) {
      if (n <= this.getNumber(this.average)) {
        return '100%'
      }
      if (n - 1 < this.getNumber(this.average) && n > this.getNumber(this.average)) {
        return `${(this.getNumber(this.average) % 1) * 100}%`
      }
      return '0%'
    }
  }
}
</script>

<style lang="scss" scoped>
.stars {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  & > span {
    font-size: 14px;
  }
  .star {
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
  }
}
</style>
